import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Form, FormHiddenNumber, FormSubmitBack, FormText } from '../../../../../../shared/form/form'
import { IconAdd } from '../../../../../../shared/icon/icon'
import { useApiFormNodeLibrary } from '../../../../../../api-new/state/content'

export const NodeLibraryAdd = ({ parentURL, parentID }) => {
  const history = useHistory()

  const apiFormNodeLibrary = useApiFormNodeLibrary()

  const handleSubmit = async data => {
    await apiFormNodeLibrary.post(data)
    history.push(parentURL)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAdd} text="Add asset">
        <CardFullHeightScrollY title="Add asset">
          <Form onSubmit={handleSubmit}>
            <FormHiddenNumber name="parentID" value={parentID} />
            <FormText label="name" name="name" autoFocus />
            <FormSubmitBack text="create asset" />
          </Form>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
